import HNSColors from "../../../ui library/HNSColors";

const sharedStyles = {
  label: (isFocused) => ({
    color: HNSColors.neutrals[500],
    fontWeight: "600",
    fontSize: "16px",
    textTransform: "capitalize",
  }),

  textField: {
    "& .MuiOutlinedInput-root": {
      padding: "0",
      borderRadius: "8px",
      transition: "border-color 0.3s",
      height: "100%",
      "& fieldset": {
        borderColor: HNSColors.neutrals[400],
      },
      "&.Mui-focused fieldset": {
        border: `1.5px solid ${HNSColors.secondary[500]}`,
      },
      "& .MuiInputBase-input": {
        padding: "10px 12px",
        fontSize: "14px",
      },
      // "& .MuiInputBase-input textarea": {
      //   padding: "15px",
      // },
      "& .MuiSelect-icon": {
        color: HNSColors.primary[500],
      },
    },
  },

  textArea: {
    "& .MuiInputBase-input": {
      height: "5rem",
      minHeight: "5rem",
      display: "flex",
      alignItems: "flex-start",
      paddingTop: "14px",
      lineHeight: "1.4",
    },
    "& .MuiInputBase-root": {
      alignItems: "flex-start",
    },
  },

  menuItem: {
    padding: "15px",
    fontSize: "14px",
    "&:hover": {
      backgroundColor: HNSColors.tertiary[700],
    },
    "&.Mui-selected": {
      backgroundColor: HNSColors.tertiary[900],
      color: HNSColors.primary[500],
      fontWeight: 600,
    },
  },

  selectMenuPaper: {
    marginTop: 1,
    borderRadius: "8px",
    backgroundColor: "#FFFFFF",
    color: HNSColors.neutrals[100],
    border: `1.5px solid ${HNSColors.secondary[500]}`,
    "& .MuiList-root": {
      padding: 0,
    },
  },
  readOnlyField: {
    "& .MuiInput-root::before": {
      borderBottom: "none",
    },
    "& .MuiInput-root:hover:not(.Mui-disabled)::before": {
      borderBottom: "none",
    },
    "& .MuiInput-root::after": {
      borderBottom: "none",
    },
    "& .MuiInputBase-readOnly": { cursor: "default" },
    "&::before": { borderBottom: "none" },
    "&:hover::before": { borderBottom: "none !important" },
    "&::after": { borderBottom: "none" },
  },
  dateTimePicker: {
    textField: {
      "& .MuiOutlinedInput-root": {
        padding: 0,
        borderRadius: "8px",
        transition: "border-color 0.3s",
        "& fieldset": {
          borderColor: HNSColors.neutrals[400],
        },
        "&.Mui-focused fieldset": {
          border: `1.5px solid ${HNSColors.secondary[500]}`,
        },
        "& .MuiInputBase-input": {
          padding: "15px",
        },
        "& .MuiInputBase-input textarea": {
          padding: "15px",
        },
        "& .MuiSelect-icon": {
          color: HNSColors.primary[500],
        },
      },
      "& .MuiInputBase-input.Mui-disabled": {
        WebkitTextFillColor: "#000000",
      },
    },
    openPickerButton: {
      marginRight: "10px",
      "&:hover": {
        backgroundColor: HNSColors.neutrals[800],
      },
    },
  },

  menuDropdownButtonStyle: {
    padding: "5px 15px",
    fontWeight: "400",
    "&:hover": {
      backgroundColor: HNSColors.secondary[600],
      color: HNSColors.neutrals[900],
      fontWeight: "600",
    },
  },

  menuItemStyle: {
    "&:hover": {
      backgroundColor: HNSColors.tertiary[900],
      color: HNSColors.primary[500],
    },
    "&.Mui-selected": {
      backgroundColor: HNSColors.tertiary[900],
      color: HNSColors.primary[500],
    },
    "&.Mui-selected:hover": {
      backgroundColor: HNSColors.tertiary[900],
    },
  },

  menuListStyle: {
    width: "250px",
    border: "1px solid",
    borderRadius: "8px",
    borderColor: HNSColors.secondary[500],
    boxShadow: "none",
    marginTop: "5px",
  },
};

export default sharedStyles;
